import { useCallback } from "react";
import Swal from "sweetalert2";

import { COLOR_GREEN, COLOR_RED } from "@static/COLORS";

export function useShowConfirmation() {
  const showConfirmation = useCallback(
    ({ onConfirm = () => undefined, title = "", text = "โปรดยืนยัน" }) => {
      Swal.fire({
        title,
        text,
        icon: "warning",
        showCancelButton: true,
        showDenyButton: true,
        confirmButtonColor: COLOR_GREEN,
        cancelButtonColor: COLOR_RED,
        confirmButtonText: "ตกลง",
        denyButtonText: "ยกเลิก",
        cancelButtonText: "cancel",
        reverseButtons: true,
        customClass: {
          title: "custom-font-swal2",
          content: "custom-font-swal2",
          confirmButton: "custom-font-swal2",
          cancelButton: "custom-font-swal2",
          denyButton: "custom-font-swal2",
        },
      }).then((result) => {
        if (result.isConfirmed) {
          onConfirm();
        }
      });
    },
    []
  );

  return showConfirmation;
}
